import { render, staticRenderFns } from "./HouseHold.vue?vue&type=template&id=31c1a042&"
import script from "./HouseHold.vue?vue&type=script&lang=js&"
export * from "./HouseHold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports